export default "/assets/images/life-saving-co-sensor.eaeedf9d1760981b.mp4";